// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-Gk0lMhFD","pic":"pic-3Z5pNgZi"};